import React from 'react'
import styled from 'styled-components'
import Colors from 'frontend_core/dist/styles/colors'
import { spacing } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'
import { signUpUrlWithQuery } from 'helpers/format'
import AppLinkSection from 'components/organisms/AppLinkSection'

// SP用レイアウト（767px以下で表示）
const SpLayout = styled.div`
  display: none;
  ${mediaMax.phone`
    display: block;
  `}
`
// 区切り線
const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${Colors.mono.gray30};
  margin: ${spacing.medium_2}px 0;
`
export default ({ showAppLink = false, ...props }) => {
  return (
    <div className="signup-box signup-box__new-account">
      <div className="row">
        <div className="signup-box__new-account-txt col-sm-12">
          <a
            href={signUpUrlWithQuery(props.config.URL)}
            className="signup-box__new-account-title"
          >
            まだアカウントの無い方は
            <span className="signup-box__new-account-linktxt">新規登録</span>
            <i className="fas fa-angle-right" />
          </a>
        </div>
      </div>
      {/* SP用: アプリで開くボックス（ログインページのみ表示） */}
      {showAppLink && (
        <SpLayout>
          <Divider />
          <AppLinkSection />
        </SpLayout>
      )}
    </div>
  )
}
